import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";

// Suppress ResizeObserver loop error (common with chart libraries and UI components, not harmful)
// This error occurs when ResizeObserver can't deliver all observations in a single animation frame
if (typeof window !== 'undefined') {
  // Suppress console.error for ResizeObserver
  const originalError = console.error;
  console.error = (...args) => {
    const errorString = args[0]?.toString?.() || '';
    if (errorString.includes('ResizeObserver loop')) {
      return;
    }
    originalError.apply(console, args);
  };
  
  // Suppress error event for ResizeObserver (prevents error overlay in dev mode)
  window.addEventListener('error', (e) => {
    if (e.message?.includes?.('ResizeObserver loop') || 
        e.error?.message?.includes?.('ResizeObserver loop')) {
      e.stopImmediatePropagation();
      e.stopPropagation();
      e.preventDefault();
      return false;
    }
  }, true);

  // Also handle unhandled rejection for ResizeObserver
  window.addEventListener('unhandledrejection', (e) => {
    if (e.reason?.message?.includes?.('ResizeObserver loop')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  }, true);

  // Override ResizeObserver to catch errors at the source
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        // Use requestAnimationFrame to prevent loop errors
        window.requestAnimationFrame(() => {
          try {
            callback(entries, observer);
          } catch (e) {
            // Silently ignore ResizeObserver errors
          }
        });
      });
    }
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
